import React, { Component } from "react"
import { Calendar, momentLocalizer } from 'react-big-calendar'
import "../../node_modules/react-big-calendar/lib/css/react-big-calendar.css";

import moment from 'moment'

{/*onSelectEvent={event => window.location.href=event.link}*/}

class CustomCalendar extends Component {
	constructor() {
		super();
		this.state = {
			currentDate: ``
		}
	}

componentDidMount() {
	function getCurrentDate() {
		const d = new Date();
		let month = (d.getMonth() + 1).toString();
		if (month.length < 2) {
			month = `0${month}`;
		}
		let day = d.getDate().toString();
		if (day.length < 2) {
			day = `0${day}`;
		}
		return `${d.getFullYear()}-${month}-${day}`;
	}

	this.setState( () => {
		return {
			currentDate: getCurrentDate()
		}
	});
}

	render() {

		var eventsArr = []
		this.props.eventsRaw && this.props.eventsRaw.map((event,key) => (
			eventsArr[key] = {},
			eventsArr[key]['title'] = event.node.title,
			eventsArr[key]['start'] = new Date(event.node.field_start_date.split("-04:00")[0]),
			eventsArr[key]['end'] = new Date(event.node.field_end_date.split("-04:00")[0]),
			eventsArr[key]['link'] = event.node.path.alias,
			eventsArr[key]['format_start_date'] = event.node.field_start_date,
			eventsArr[key]['format_end_date'] = event.node.field_end_date
		))
		const localizer = momentLocalizer(moment)
		const date = this.state.currentDate
		// const formats = {
		//   weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dddd', culture),
		// }
		let formats = {

			dateFormat: 'D',
			dayFormat: (date, culture, localizer) =>
			localizer.format(date, 'DDD', culture),

			weekdayFormat: (date, culture, localizer) =>
			localizer.format(date, 'dddd', culture),

			dayRangeHeaderFormat: ({ start, end }, culture, local) =>
			local.format(start, { date: 'short' }, culture) + ' — ' +
			local.format(end, { date: 'short' }, culture)
		}
		return (
			<div className="events-calendar">
				<Calendar
					localizer={localizer}
					formats={formats}
					defaultDate={new Date()}
					views={['month','day']}
					defaultView="month"
					events={eventsArr}
					style={{ height: "976px" }}
					onSelectEvent={event => window.location.href=event.link}
					eventPropGetter={function(event, start, end, isSelected) {
						if (event.format_start_date < date)  {
							var style = {
								position: 'relative',
								backgroundColor: '#E8E8E8',
								zIndex: 10
							};

						} else {
							var style = {
								position: 'relative',
								zIndex: 10
							};
						}

		return {
			style: style
		};
	}}
				/>
			</div>
		)
	}
}

export default CustomCalendar
